<template>
  <v-card
    class="membership"
    max-height="500px"
  >
    <v-card-title class="greyee">
      <span class="font-weight-medium">{{ '$l.case.membership' | translate }}</span>
    </v-card-title>

    <v-card-text
      v-for="(item, index) in match.detail.membership"
      :key="index"
    >
      <div v-if="checkIfEmpty(item.name)">
        {{ $i18n.t('$l.case.memberName') + ': ' + item.name }}
      </div>

      <div v-if="checkIfEmpty(item.function)">
        {{ $i18n.t('$l.case.function') + ': ' + item.function }}
      </div>

      <div v-if="checkIfEmpty(item.startDate)">
        {{ $i18n.t('$l.case.startDate') + ': ' + item.startDate }}
      </div>

      <div v-if="checkIfEmpty(item.endDate)">
        {{ $i18n.t('$l.case.endDate') + ': ' + item.endDate }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Membership',
  props: {
    match: {
      type: Object,
      required: true
    }
  },
  methods: {
    checkIfEmpty (data) {
      if (data && data.length > 0 && data !== 'null' && data !== 'unknown' && data !== undefined) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .membership {
    overflow-y: scroll;
  }
</style>
